"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const categories_1 = require("companion-app-components/flux/categories");
const budgetSummaryItem_1 = __importDefault(require("./budgetSummaryItem"));
const calculateSummaryTotals = (budgetItems) => {
    const newSummary = { income: 0, expenses: 0, balance: 0 };
    budgetItems.forEach((item) => {
        switch (item.type) {
            case 'GROUP':
                if (item.amount > 0) {
                    newSummary.income += Number(item.amount);
                }
                else {
                    newSummary.expenses += Number(item.amount);
                }
                break;
            default:
                if (item.coa && item.coa.type === 'CATEGORY' && categories_1.categoriesSelectors.isIncomeCat(null, item.coa.id)) {
                    newSummary.income += Number(item.amount);
                }
                else {
                    newSummary.expenses += Number(item.amount);
                }
                break;
        }
    });
    newSummary.balance = newSummary.income + newSummary.expenses;
    return newSummary;
};
const BudgetSummary = ({ budgetItems, classes, currency = 'USD' }) => {
    const [summaryTotals, setSummaryTotals] = (0, react_1.useState)({ income: 0, expenses: 0, balance: 0 });
    (0, react_1.useEffect)(() => {
        setSummaryTotals(calculateSummaryTotals(budgetItems));
    }, [budgetItems]);
    return (<div className={classes.budgetSummary}>
      <div style={{
            display: 'flex',
            flexDirection: 'row',
        }}>
        <Typography_1.default variant="subtitle1" className={classes.summaryHeader}>
          BUDGET SUMMARY
        </Typography_1.default>
        <budgetSummaryItem_1.default classes={classes} title="INCOME" currency={currency} amount={summaryTotals.income} disableColor/>
        <budgetSummaryItem_1.default classes={classes} title="EXPENSES" currency={currency} amount={summaryTotals.expenses}/>
        <budgetSummaryItem_1.default classes={classes} title="SAVINGS" currency={currency} amount={summaryTotals.balance}/>
      </div>
    </div>);
};
exports.default = BudgetSummary;
